'use strict';

/* global $ */
/* global _ */
/* global Cookies */

import { getAjax } from '../utils/ajax';
import { Products } from './order/products';


function SaleInit (options) {
    var opt = _.merge({ }, {
        wrap: '.js-header-sale',
        product: '.js-product-sale',
    }, options);

    class Sale {
        start(options) {
            let self = this;

            self.opt = _.extend({ }, options);

            if(!Cookies.get('sale_closed')){
                // Инициализируем блоки товаров на сайте
                self.products = new Products();
                self.getSale();
            }
        }
        getSale(){
            let self = this;

            let data = {
                _do: 'get_sale',
                result: 'json'
            };

            getAjax(data,
                {
                    url: '/json/'
                }
            )
            .then(function (response) {
                self.clearSale();

                if(response.data){
                    self.showSale(response.data);
                    // self.initProducts(response.data);
                }
            })
            .catch(function (error) {
                console.log(error);
            });
        }
        showSale(data){
            let self = this;
            if(data.content){
                self.$el = $(document.createElement('div'))
                                    .addClass('sale-block')
                                    .html(data.content)
                                    .appendTo($('body'));
                self.$el.on('click', '.js-sale-close', function(){ self.closeSale(); });
                self.$el.on('click', '.js-sale-more', function(){ self.getSale(); });

                self.products.init({
                    product: self.opt.selectors.product,
                    product_count: self.opt.selectors.product_count,
                    product_buy: self.opt.selectors.product_buy
                });
            }
        }
        closeSale() {
            let self = this;
            self.clearSale();
            var inHalfADay = 0.5;
            Cookies.set('sale_closed', true, { expires: inHalfADay, path: '/' });
        }
        clearSale(){
            let self = this;
            if(self.products){
                self.products.clear();
            }
            if(self.$el){
                self.$el.off().remove();
            }
        }
        // initProducts(data){
        //     let self = this;
        //     self.products.clear();
        //     if(data.content){
        //         // $(window).trigger('reposition');
        //     } else {
        //         self.$wrap.html('');
        //     }
        // }
    }

    let sale = new Sale();
    sale.start({
        selectors: {
            wrap: opt.wrap,
            product: opt.product,
            product_count: opt.product_count,
            product_buy: opt.product_buy
        }
    });
}

export {
    SaleInit
};

